import { render, staticRenderFns } from "./PowerControlMenu.vue?vue&type=template&id=4ae106b4&scoped=true"
import script from "./PowerControlMenu.vue?vue&type=script&lang=js"
export * from "./PowerControlMenu.vue?vue&type=script&lang=js"
import style0 from "./PowerControlMenu.vue?vue&type=style&index=0&id=4ae106b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae106b4",
  null
  
)

export default component.exports